import axios from "axios";
import { RestError } from "./RestService";
//import appSettings from "../../app-settings.json";

// const appSettings:any = {
//     apiBaseUrl: ""
// }

// axios.defaults.baseURL = appSettings.apiBaseUrl;

axios.defaults.headers.common['Content-Type'] = 'application/json';
//axios.defaults.headers = {'Content-Type': 'application/json'};

//@@KG cannot do this because will cause CORS error when making token calls after a token exists
// axios.interceptors.request.use(async (req) =>  {
//     // `req` is the Axios request config, so you can modify
//     // the `headers`.

//     try {
//         const token = await ELynxAuthService.acquireToken();
//         if (token) {
//             req.headers.authorization = `bearer ${token}`;
//         }

//     } catch(error) {
//         console.log('do something')

//     }
//     return req;
//   });

// let redirecting = false;

// axios.interceptors.request.use((config) => {

//     let authHeader: string | undefined = config.headers['authorization'];


//     console.log('Request Authorization Header:', authHeader);

//     if (authHeader) {
//         authHeader = authHeader.replace('bearer ', '');
//     }

//     if ((!authHeader || authHeader === '' || authHeader === 'null') && window.location.pathname !== '/login' && window.location.pathname !== '/change-password') {
//     //if (/* your condition to cancel, e.g., missing token */ true) {
//         const controller = new AbortController();
//         // Attach signal to this specific request
//         config.signal = controller.signal;
        
//         // Immediately abort the request
//         controller.abort('Request cancelled by interceptor logic.');

//         if (!redirecting) {
//             redirecting = true;
//             window.location.href = '/login';
//         }
//     } else {
//         redirecting = true;
//     }


//     return config;
// }, (error) => {
//     return Promise.reject(error);
// });

axios.interceptors.response.use((response) => {
    return response;
}, (error: RestError) => {

    //console.log(`rest error: ${JSON.stringify(error)}`);
    //
    //alert(`REST ERROR: ${JSON.stringify(error)}`);

    //debugger;

    error.offline = !error.response && error.message?.toLowerCase() === 'network error';

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    //@@ global error handler?
    return Promise.reject(error);
});

export default axios;